import LinkButton from "@components/Buttons/LinkButton"
import React from "react"
import * as S from "./elements"
import formatPrice from "@lib/formatPrice"
import IntlLink from "@components/Intl/IntlLink"
import { useIntl } from "@components/Intl"
import { Box } from "@components/Layout"

interface Props {
  title: string
  price: number
  image: string
  href: string
  as: string
  isLoading: boolean
  handleConfigure?: () => void
  handleAddToBag?: () => void
}

export const InThisLook: React.FC<Props> = ({
  title,
  price,
  image,
  href,
  as,
  isLoading,
  handleAddToBag,
  handleConfigure,
}) => {
  const { messages } = useIntl()
  return (
    <S.Anchor>
      <S.ImgWrapper>
        <img src={image} alt={title} />
      </S.ImgWrapper>
      <S.InfoWrapper>
        <IntlLink href={href} as={as}>
          <a href={as} style={{ textDecoration: "none" }}>
            <S.Title as="h3">{title}</S.Title>
          </a>
        </IntlLink>
        <S.Price>{formatPrice(price)}</S.Price>
        {(handleConfigure || handleAddToBag) && (
          <S.ActionWrapper>
            {handleConfigure && (
              <Box mr={2}>
                <LinkButton
                  title={messages.global.configure}
                  onClick={handleConfigure}
                >
                  {messages.global.configure}
                </LinkButton>
              </Box>
            )}

            {handleAddToBag && (
              <S.AddToBag isLoading={isLoading}>
                <LinkButton
                  disabled={isLoading}
                  title={messages.global.addToBag}
                  icon="add-to-bag"
                  onClick={handleAddToBag}
                >
                  {messages.global.addToBag}
                </LinkButton>
              </S.AddToBag>
            )}
          </S.ActionWrapper>
        )}
      </S.InfoWrapper>
    </S.Anchor>
  )
}
